import { ResourceStatus } from "@prisma/postgresClient";

export default ResourceStatus;
